/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {BackfillCustomers2Request} from '@cash-web/protos/squareup/cash/customersearch/api/BackfillCustomers2.pb'
import {BackfillCustomers2Response} from '@cash-web/protos/squareup/cash/customersearch/api/BackfillCustomers2.pb'


export const backfillCustomers2 = (request:BackfillCustomers2Request, options?: CashRequestOptions) => post<BackfillCustomers2Request, BackfillCustomers2Response>("/2.0/cash/backfill-customers2", request, {...options, rejectOnError: true })